import { getPolyglot } from '../../../../../i18n';
import Link from '../../../../../theme/components/Link';
import React from 'react';
import { StyledMenuItemPrimary } from '../../../../../components/App/header/AvatarMenu/AvatarMenu';

export const FWAvatarLinks = () => {
  const urlAboutUs = 'https://structuralconcepts.com/';
  const urlTermsAndConditions =
    'https://djnnwndagrfti.cloudfront.net/resources/Shared/TERMS_AND_CONDITIONS_OF_SALE.pdf';
  const urlPrivacyPolicy = 'https://structuralconcepts.com/privacy-policy';

  const polyglot = getPolyglot();
  return (
    <>
      <Link to={urlTermsAndConditions} target="_blank">
        <StyledMenuItemPrimary>
          {polyglot.t('footer.terms_and_conditions')}
        </StyledMenuItemPrimary>
      </Link>
      <Link to={urlPrivacyPolicy} target="_blank">
        <StyledMenuItemPrimary>
          {polyglot.t('footer.privacy_policy')}
        </StyledMenuItemPrimary>
      </Link>
      <Link to={urlAboutUs} target="_blank">
        <StyledMenuItemPrimary>
          {polyglot.t('footer.about_us')}
        </StyledMenuItemPrimary>
      </Link>
    </>
  );
};
